<template>
  <div class="small-form-grid">
    <div class="grid-x grid-padding-x">
      <div class="cell large-12">
        <span class="small-form-grid-heading">Forklaringer</span>
        <ul class="color-row-helper">
          <li><span class="color-row-text-gray">Usolgt</span></li>
          <li><span class="color-row-bg-red">Med forbehold</span></li>
          <li><span class="color-row-bg-yellow">Solgt - ikke fakt.</span></li>
          <li><span class="color-row-bg-green color-row-text-red">Fakt. - ubetalt</span></li>
          <li><span class="color-row-bg-green">Fakt. - betalt</span></li>
          <li><span class="color-row-bg-blue color-row-text-red">Retur - ubetalt</span></li>
          <li><span class="color-row-bg-blue">Retur - betalt</span></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheSidebarColorCodes'
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Tilslagsskjermbilde/TheSidebarColorCodes.vue